import request from '@/utils/request'

// 盲盒信息接口
export type metaBlindBoxInfoResponse = {
  blindBoxGifOpened: string
  blindBoxGifUNopen: string
  blindBoxOpenStatus: string // 今日盲盒开启状态：0、未开启；1、已开启
  blindBoxLinkUrl: string
  blindBoxStatus: string
}
export function metaBlindBoxInfo() {
  return request<metaBlindBoxInfoResponse>({
    url: '/v1/api/eas/user/metaBlindBoxInfo',
    method: 'GET'
  })
}

// 盲盒牌照号码数据
export type businessLicenseNumResponse = {
  result: string[]
}
export function businessLicenseNum() {
  return request<businessLicenseNumResponse>({
    url: '/v1/api/eas/user/businessLicenseNum',
    method: 'GET'
  })
}
// 已开盲盒信息
export type blindBoxInfoResponse = {
  result: {
    nextBlindBoxTime: number
    todayOpenTimes: number // 今日已开盲盒次数
    currentMonthOpenTimes: number // 本月已开盲盒次数
    todayRemainTimes: number // 今日剩余盲盒开启次数
    boxStatus: number // 盲盒奖励状态:<br />0、积分、减碳值、优惠券都未中奖<br/>1、积分、减碳值未中奖，优惠券中奖<br/>2、积分未中奖、减碳值中奖、优惠券未中奖<br/>3、积分未中奖、减碳值中奖、优惠券中奖<br/>4、积分中奖、减碳值未中奖、优惠券未中奖<br/>5、积分中奖、减碳值未中奖、优惠券中奖<br/>6、积分中奖、减碳值中奖、优惠券未中奖<br/>7、积分中奖、减碳值中奖、优惠券中奖 |
    btnState: number //push开关的状态 0 关闭 1开启
  }
}
export function fetchBlindBoxInfo() {
  return request<blindBoxInfoResponse>({
    url: '/v1/api/eas/user/blindBoxInfoNew',
    method: 'post'
  })
}

// 开盲盒接口
export type blindBoxDrawResponse = {
  result: {
    luckyCardId: number //今日幸运卡id
    nextBlindBoxTime: number
    resultList: {
      prizeStatus: boolean // 中奖状态
      prize: string // 名称
      prizeType: number // 奖品类型 0-未中奖 1-积分 2-减碳 3-电子券
      isBigPrize: boolean // 是否是大奖
      shareFlag?: boolean
      jumpUrl?:string //跳转链接
    }[]
  }
}
export function blindBoxDraw() {
  return request<blindBoxDrawResponse>({
    url: '/v1/api/eas/user/blindBoxDraw',
    method: 'post'
  })
}
// 跑马灯
export type blindBoxRollingResponse = {
  result: {
    award: string // 奖励名称
    phone: number // 手机号
  }[]
}
export function blindBoxRolling() {
  return request<blindBoxRollingResponse>({
    url: '/v1/api/eas/user/blindBoxRolling',
    method: 'get'
  })
}

// 同是否意条款
export type isAgreeResponse = {
  result: boolean
}
export function isAgreeInfo() {
  return request<isAgreeResponse>({
    url: '/v1/api/eas/user/isAgree',
    method: 'get'
  })
}
// 修改用户条款状态为同意接口
export type agreementResponse = {
  header: {
    resultCode: number
  }
}
export function handelAgreement() {
  return request<agreementResponse>({
    url: '/v1/api/eas/user/agreement',
    method: 'get'
  })
}
// 检查风控接口
export type riskManageResponse = {
  result: boolean // 是否触发封控
}
export function riskManage() {
  return request<riskManageResponse>({
    url: '/v1/api/eas/user/riskManage',
    method: 'get'
  })
}

// 检查IP地址接口
export type ipAddressResponse = boolean
export function checkIpAddress() {
  return request<ipAddressResponse>({
    url: '/v1/api/news/accOperation/isCNMainLandIp',
    method: 'get'
  })
}
//每一天的券列表
export type calendarListItemType = {
  code: any
  name: string
  //图片链接
  iconUrl: string
  //开始时间
  startTime: string
  endTime: string
  //总库存
  stock: number
  //已使用库存数
  stockUsed: number
  //时间状态 1待开始 2已开始 3已过期
  timeType?: number,
  useLink?: string
}
//日历面板item
export type dateListItmeType = {
  id?: number
  year: number
  month: number
  week: number
  day: number
  //1 特殊节日 2 普通
  hkHoliday: boolean
  //1 当天 current 2之前 before 3之后 after
  timeTag: string
  // totalNum: number
  //是否选中
  flag?: boolean
  //是否已抢券
  couponState?: boolean
  //券列表 //已弃用
  calendarList: Array<calendarListItemType>
  //当天是否签到
  integralState?: boolean
  //10.7.5新增
  hasEligibleAward:boolean//是否有资格领券
  hasGeneralAward:boolean//是否有资格领券
  isAwardAllGone:boolean//是否领完
  awardType?:number
  extraCouponStatus:boolean//是否需要展示额外券
  extraIntegralStatus:boolean//是否需要展示额外积分
}
//日历面板result
// export type dateListItmeTypeResult={
//   result:Array<dateListItmeType>
// }
//获取日历面板
export function getDateComponentList() {
  return request<{ result: Array<dateListItmeType> }>({
    url: '/v1/api/eas/user/blindBoxCalendarV2',
    method: 'get'
  })
}

// type blindBoxIntegralStateResult = {
//   result: {
//     signInState: boolean
//     signInCount: number
//   }
// }
// 盲盒积分签到状态
// export function blindBoxIntegralState() {
//   return request<blindBoxIntegralStateResult>({
//     url: '/v1/api/eas/user/blindBoxIntegralState',
//     method: 'get'
//   })
// }

export type blindBoxDetailType = {
  //是否办理会员 true 显示办理会员 false 不显示
  linkVipPopWindowState:boolean
  //当天是否积分签到
  signInState: boolean
  linkVipStatus: boolean
  linkVipVersion: string
  postPaid: boolean
  //	本月累积签到次数
  signInCount: number
  //当天是否抢卡券
  couponState: boolean
  //节日或者节气
  solarTerm: string
  year: string
  monthDay: string
  week: string
  //农历
  chinaDate: string
  //盲盒状态0:未开
  //盲盒状态13：空
  //1-12
  blindBoxState: {
    nextBlindBoxTime?: number
    todayOpenTimes?: number // 今日已开盲盒次数
    currentMonthOpenTimes?: number // 本月已开盲盒次数
    todayRemainTimes?: number // 今日剩余盲盒开启次数
    boxStatus?: number // 盲盒奖励状态:<br />0、积分、减碳值、优惠券都未中奖<br/>1、积分、减碳值未中奖，优惠券中奖<br/>2、积分未中奖、减碳值中奖、优惠券未中奖<br/>3、积分未中奖、减碳值中奖、优惠券中奖<br/>4、积分中奖、减碳值未中奖、优惠券未中奖<br/>5、积分中奖、减碳值未中奖、优惠券中奖<br/>6、积分中奖、减碳值中奖、优惠券未中奖<br/>7、积分中奖、减碳值中奖、优惠券中奖 |
    btnState?: number //push开关的状态 0 关闭 1开启
  }
  //每日箴言
  //字段和以前一样
  dailyCard: Record<string, string>
  //额外积分
  extraIntegralStatus:boolean
  //额外券
  extraCouponStatus:boolean
  //显示萌宠小红点
  petRedDotState:boolean
  //宠物页面链接
  petPageLinkUrl:string
}
//获取每一天的日历详情数据
export function getEveryDayDetail(data: { date: string }) {
  return request<{ result: blindBoxDetailType }>({
    url: '/v1/api/eas/user/blindBoxCalendarDetail',
    method: 'get',
    params: data
  })
}
//新增一个记录用户已看过办理会员弹窗的接口： /v1/api/eas/user/blindBox/linkVip/recordPopWindow
export function blindBoxLinkVipRecordPopWindow() {
  return request({
    url: '/v1/api/eas/user/blindBox/linkVip/recordPopWindow',
    method: 'get'
  })
}
type blindBoxCouponType={
  //"奖品编码（不用管）"
  awardCode:any
  //"奖品名称"
  awardName:string
  //奖品数量
  awardNum:number
  //奖品使用跳转链接
  useLink:string
  //图片链接
  iconUrl:string
  awardType?:number
  isHighValueAward?:boolean
}
//抢券
export function blindBoxCoupon() {
  return request<{result:Array<blindBoxCouponType>}>({
    url: '/v1/api/eas/user/blindBoxCoupon',
    method: 'post'
  })
}
//积分签到/v1/api/eas/sign/sign_in
export type SignInStype = {
  center: {
    signInfo: {
      integral: number
      signInIntegral: number
      signInExtraIntegral?: number
    }
  }
}
export function SignIn() {
  return request<SignInStype>({
    url: '/v1/api/eas/sign/sign_in',
    method: 'get'
  })
}
//myprops类型
//抢券弹窗
export type myPropsType = {
  showDialog: boolean,
  //1领积分 2抢券成功 3卡券已完(失败) 4抢券说明 5带时间的抢券说明 6风控
  type: number,
  container?: {
    title?: string
    smallText?: string
    url?: string
    iconUrl?: string
    btnText?: string
    codeName?: string
    signInExtraIntegral?: string
    signInExtraIntegralUrl?: string
    list?: Array<Record<string, any>>
  },
  containerNew?:{
    img?:string
    link?:string
    carousel_umkey?:string
  }|undefined,
  containerForPoints?:{
    img?:string
    link?:string
    carousel_umkey?:string
  }|undefined,
  googleContainer?:GoogleCoupon
}
//是否同意抢卡券的条款
export function isAgreeTicket() {
  return request<{ result: boolean }>({
    url: '/v1/api/eas/user/integral/isAgree',
    method: 'get'
  })
}
//同意抢券和领积分的接口/v1/api/eas/user/integral/agree
export function agreeRules() {
  return request({
    url: '/v1/api/eas/user/integral/agree',
    method: 'get'
  })
}
//开盲盒数据类型 通用item
export type blindBoxHistoryItemType={
  name:string
  createTime:string
  time:string
  awardCode?:string
}
//开盲盒数据类型 通用Array<item>
type blindBoxHistoryCommon={
  [key:string]:Array<blindBoxHistoryItemType>
}
//近期开盲盒的记录 数据类型 对象 
type blindBoxHistoryType ={
  result:blindBoxHistoryCommon
}
///v1/api/eas/user/blindBoxHistory 近期开盲盒的记录
export function blindBoxHistory(){
  return request<blindBoxHistoryType>({
    url:"/v1/api/eas/user/blindBoxHistory",
    method:"get",
  })
}

///v1/api/eas/user/blindBoxHistoryMonth 某个月的开盲盒记录
type blindBoxHistoryMonthReqType={
  year:string|number
  month:string|number
}
export function blindBoxHistoryMonth(params:blindBoxHistoryMonthReqType){
  return request<blindBoxHistoryCommon>({
    url:"/v1/api/eas/user/blindBoxHistoryMonth",
    method:"get",
    params
  })
}
///v1/api/eas/user/couponHistory 抢券记录 6个月
export function couponHistory(){
  return request<blindBoxHistoryType>({
    url:"/v1/api/eas/user/couponHistory",
    method:"get",
  })
}

///v1/api/eas/user/couponHistoryMonth 抢券记录 某个月
export function couponHistoryMonth(params:blindBoxHistoryMonthReqType){
  return request<blindBoxHistoryCommon>({
    url:"/v1/api/eas/user/couponHistoryMonth",
    method:"get",
    params
  })
}
//首次进入/v1/api/eas/luckyCard/user/blindBox/buttonFirst

export function  ButtonFirst(){
  return request({
    url:"/v1/api/eas/luckyCard/user/blindBox/buttonFirst",
    method:"get",
  })
}


//获取日历列表详情数据
///v1/api/eas/user/calendarCouponDetail
export type calendarCouponDetailItemType = {
  code:string
  endTime:string
  iconUrl:string
  isEligible:boolean
  isEligibleAward:boolean
  name:string
  startTime:string
  stock:number
  stockRest:number
  stockUsed:number
  useLink:string
  timeType?:number
  isHighValueAward?:boolean

}
type calendarCouponDetailType={
  result:Array<calendarCouponDetailItemType>
}

export function  getCalendarCouponDetail(data:{date:string}){
  return request<calendarCouponDetailType>({
    url:"/v1/api/eas/user/calendarCouponDetail",
    method:"get",
    params: data
  })
}
//获取当日中奖信息
type couponHistoryDayReqType={
  year:string|number
  month:string|number
  day:string|number
}
///v1/api/eas/user/couponHistoryByUser
export function getCouponHistoryByUser(params:couponHistoryDayReqType){
  return request<blindBoxHistoryCommon>({
    url:"/v1/api/eas/user/couponHistoryByUser",
    method:"get",
    params
  })
}



//10.8新增接口 获取当日是否已经点击查看券列表 /v1/api/eas/user/blindBoxCalendar/isClick
export function getIsClickApi(){
  return request<{result:{click:boolean}}>({
    url:"/v1/api/eas/user/blindBoxCalendar/isClick",
    method:"get"
  })
}

//10.8新增记录用户当天是否点过小卡/v1/api/eas/user/blindBoxCalendar/click
export function changeClickApi(){
  return request({
    url:"/v1/api/eas/user/blindBoxCalendar/click",
    method:"post"
  })
}

//11.2 任务乐园活动弹窗改造 查询活动接口 /v1/api/ad/getTaskCenterAd
export type TaskCenterAdType = {
  link:string,
  img:string,
  group_id:string,
  umkey:string,
  carousel_umkey:string,
}
export function getTaskCenterAdApi(params:{adType:number,year:number,month:number,day:number}){
  return request<TaskCenterAdType|Array<TaskCenterAdType>>({
    url:"/v1/api/ad/getTaskCenterAd",
    method:"get",
    params
  })
}
export interface GoogleCouponResponse  {
  data?:any
  showState?:boolean
  adId:string
}
export interface GoogleCoupon extends GoogleCouponResponse {
  type:string,
  img?:string,
  googleAdsStatus?:string,
}
//获取谷歌广告unitId 查询用户当天是否有可领取（卡券）的广告奖励
export function getAdCoupon(){
  return request<{result:GoogleCouponResponse}>({
    url:"/v1/api/eas/user/blindBox/adCoupon",
    method:"get"
  })
}

export type sendAdCouponType={
  awardCode:string//奖品编码
  awardName:string//奖品名称
  awardNum:number//奖品数量
  useLink:string//奖品使用跳转地址
  iconUrl:string
  awardType:number //1cms券 2电商券 3 ubd券
}
//用户观看完google广告后发卡券接口
export async function sendAdCoupon(params:{awardCode:string}){
  return await request<{result:sendAdCouponType}>({
    url:"/v1/api/eas/user/blindBox/sendAdCoupon",
    method:"get",
    params
  })
}
//用户观看完google广告后发积分接口
export async function sendAdIntegral(){
  return await request({
    url:"/v1/api/eas/user/blindBox/sendAdIntegral",
    method:"get",
  })
}

//googlebanner数据类型接口
export interface googleBannerResponse{ 
  imgUrl0:string
  imgUrl1:string
  rewardTimes:number
  showState:boolean
  umkey:string
  umkeyPlay:string
  umkeyEnd:string
}


//获取google广告banner接口 /v1/api/eas/user/blindBox/googleBanner
export async function getGoogleBannerApi(){
  return await request<{result:googleBannerResponse}>({
    url:"/v1/api/eas/user/blindBox/googleBanner",
    method:"get",
  })
}
//点击谷歌banner广告前检查设备风控接口/v1/api/eas/user/blindBox/googleBanner/riskCheck
export  async function getGoogleBannerRiskCheckApi(){
  return await request<{result:boolean}>({
    url:"/v1/api/eas/user/blindBox/googleBanner/riskCheck",
    method:"get",
  })
}
//用户观看完google banner广告后发积分接口 /v1/api/eas/user/blindBox/googleBanner/sendAdIntegral
export async function sendGoogleBannerAdIntegral(){
  return await request({
    url:"/v1/api/eas/user/blindBox/googleBanner/sendAdIntegral",
    method:"get",
  })
}

//12.0获取任务乐园弹窗广告 /v1/api/ad/PopupWindow/isVisable
export interface popupWindowListItem {
  id:number
  img:string
  img_sc:string
  img_tc:string
  img_en:string
}
export interface TaskCenterPopupWindowResponse{ 
  popupWindowList:Array<popupWindowListItem>
  pageId:string
  isVisable:number //1显示 0不显示
}
export async function getTaskCenterPopupWindow(pageId:string){
  return await request<TaskCenterPopupWindowResponse>({
    url:"/v1/api/ad/PopupWindow/isVisable",
    method:"post",
    data:{body:{pageId}}
  })
}

//点击弹窗按钮触发请求 /v1/api/ad/PopupWindow/noThanks
export async function noThanks(id:number){
  return await request<any>({
    url:"/v1/api/ad/PopupWindow/noThanks",
    method:"get",
    params:{id}
  })
}

export let ceshiList = [
  {
    // "uiMetadata":""
    "code": "01ab0150dcc44e098754915e07658f62_2024-08-03",
    "endTime": "2024-08-09 23:02:57",
    "iconUrl": "https://uatoss.mylinkapp.hk/via/resource/activity/2024-08-01/4dd4eee3771646f39b62a4f64de2e743.JPG",
    "isEligible": true,
    "isEligibleAward": false,
    "name": "匯款日:熊貓速匯-匯款免手續費電子券",
    "startTime": "2024-08-09 03:02:57",
    "stock": 1000,
    "stockRest": 0,
    "stockUsed": 1000,
    "useLink": "openurl-modal://http://8.217.51.162:18009/proList?forceHideNavigationBar=true&lang=<<cmcchkhsh_cmplang>>&actId=1782609157512130560&isShowShopCategory=1"
  },
  {
    "code": "01ab0150dcc44e098754915e07658f62_2024-08-03",
    "endTime": "2024-08-09 23:02:57",
    "iconUrl": "https://uatoss.mylinkapp.hk/via/resource/activity/2024-08-01/4dd4eee3771646f39b62a4f64de2e743.JPG",
    "isEligible": true,
    "isEligibleAward": false,
    "name": "匯款日:熊貓速匯-匯款免手續費電子券",
    "startTime": "2024-08-09 03:02:57",
    "stock": 1000,
    "stockRest": 0,
    "stockUsed": 1000,
    "useLink": "openurl-modal://http://8.217.51.162:18009/proList?forceHideNavigationBar=true&lang=<<cmcchkhsh_cmplang>>&actId=1782609157512130560&isShowShopCategory=1"
  },
  {
    "code": "01ab0150dcc44e098754915e07658f62_2024-08-03",
    "endTime": "2024-08-09 23:02:57",
    "iconUrl": "https://uatoss.mylinkapp.hk/via/resource/activity/2024-08-01/4dd4eee3771646f39b62a4f64de2e743.JPG",
    "isEligible": true,
    "isEligibleAward": false,
    "name": "匯款日:熊貓速匯-匯款免手續費電子券",
    "startTime": "2024-08-09 03:02:57",
    "stock": 1000,
    "stockRest": 0,
    "stockUsed": 1000,
    "useLink": "openurl-modal://http://8.217.51.162:18009/proList?forceHideNavigationBar=true&lang=<<cmcchkhsh_cmplang>>&actId=1782609157512130560&isShowShopCategory=1"
  }
]

// 是否可以弹出提示签到 /v1/api/eas/user/blindBox/signInRemind 返回body.state = true
export async function getSignInRemind(){
  return await request<{result?:{state:boolean}}>({
    url:"/v1/api/eas/user/blindBox/signInRemind",
    method:"get",
  })
}
//弹出弹窗后调用这个接口 /v1/api/eas/user/blindBox/signInRemind/show
export async function showSignInRemind(){
  return await request({
    url:"/v1/api/eas/user/blindBox/signInRemind/show",
    method:"get",
  })
}

//查询是否显示PFP头像入口接口 /v1/api/eas/isShowPFP
export async function getIsShowPFP(){
  return await request<{isShow:String}>({
    url:"/v1/api/eas/isShowPFP",
    method:"get",
  })
}